import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiper1 = new Swiper(".section1 .cont1 .mySwiper", {
  speed: 600,
  autoplay: { // 自动切换
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
  on:{
    init: function(swiper){
      $('.section1 .cont1 .common-news-swiper .swiper-tab li').eq(0).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section1 .cont1 .common-news-swiper .swiper-tab li').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  },
})

$('.section1 .cont1 .common-news-swiper .swiper-tab li').hover(function(){
  let index = $(this).index()
  swiper1.slideTo(index)
})


var swiper2 = new Swiper(".section1 .cont2 .mySwiper", {
  speed: 600,
  autoplay: { // 自动切换
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
  on:{
    init: function(swiper){
      $('.section1 .cont2 .common-news-swiper .swiper-tab li').eq(0).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section1 .cont2 .common-news-swiper .swiper-tab li').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  },
})

$('.section1 .cont2 .common-news-swiper .swiper-tab li').hover(function(){
  let index = $(this).index()
  swiper2.slideTo(index)
})


var swiper3 = new Swiper(".section1 .cont3 .mySwiper", {
  speed: 600,
  autoplay: { // 自动切换
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
  on:{
    init: function(swiper){
      $('.section1 .cont3 .common-news-swiper .swiper-tab li').eq(0).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section1 .cont3 .common-news-swiper .swiper-tab li').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  },
})

$('.section1 .cont3 .common-news-swiper .swiper-tab li').hover(function(){
  let index = $(this).index()
  swiper3.slideTo(index)
})

if($('.section1 .cont4').length>0){
  var swiper4 = new Swiper(".section1 .cont4 .mySwiper", {
    speed: 600,
    autoplay: { // 自动切换
      delay: 3000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    on:{
      init: function(swiper){
        $('.section1 .cont4 .common-news-swiper .swiper-tab li').eq(0).addClass('active')
      },
      slideChangeTransitionStart: function(){
        $('.section1 .cont4 .common-news-swiper .swiper-tab li').eq(this.realIndex).addClass('active').siblings().removeClass('active')
      },
    },
  })
  
  $('.section1 .cont4 .common-news-swiper .swiper-tab li').hover(function(){
    let index = $(this).index()
    swiper4.slideTo(index)
  })
}
